import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import TextFieldForObjectState from "../../../components/Questions/TextFields/TextFieldForObjectState";

import SelectFieldForObjectState from "../../../components/Questions/TextFields/SelectFieldForObjectState";
import CheckConditions from "../../../components/Questions/CheckConditions";
import { Arr_SENDInfo } from "../../../../arrays/SEF/Arr_SENDInfo";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import getArrayOfNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfNeededToSubmit";

function ViewSEFSENDInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formInfo, setformInfo] = useState({});
  //Get all questions for this page
  const { arrayOfQuestions, neededToSubmit } =
    getArrayOfQuestionsAndNeededToSubmit("SENDInfo", formInfo, Arr_SENDInfo);

  //

  const isFormComplete = neededToSubmit.length === 0;

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  const [SEFProgress, setSEFProgress] = useState({
    SENDInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFSENDInfo",
      setformInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFSENDInfo: formInfo,
        "SEFProgress.SENDInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  //If all values in every prop of formInfo are "No", let ThisPageSubmit = "Complete"
  let ThisPageSubmitValue = "Awaiting_Review";
  if (Object.values(formInfo).every((val) => val === "No")) {
    ThisPageSubmitValue = "Complete";
  }

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFSENDInfo: formInfo,
        "SEFProgress.SENDInfo": ThisPageSubmitValue,
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      SENDInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  let Arr_Topics = [
    {
      Topic: "ADHD/ ADD",
      ask: 0,
      start: 1,
      end: 32,
      ask_title: "Arr_SENDInfo_ADHD",
    },
    {
      Topic: "Special Educational Needs",
      ask: 33,
      start: 34,
      end: 66,
      ask_title: "Arr_SENDInfo_learning_need",
    },
    {
      Topic: "Autism",
      ask: 67,
      start: 68,
      end: 98,
      ask_title: "Arr_SENDInfo_autistic",
    },
    {
      Topic: "Speech Language",
      ask: 99,
      start: 100,
      end: 127,
      ask_title: "Arr_SENDInfo_speech_language",
    },
    {
      Topic: "Other Special Educational Needs and/ or Disabilities",
      ask: 128,
      start: 129,
      end: 156,
      ask_title: "Arr_SENDInfo_other",
    },
  ];

  return (
    <div className="view-basic-info-container">
      <h1>Summer Information</h1>

      {SEFProgress &&
      SEFProgress.SENDInfo &&
      (SEFProgress.SENDInfo === "Complete" ||
        SEFProgress.SENDInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}
      <form className="view-basic-info-form">
        <h2>SEND Info</h2>
        <p>
          Health, well-being and safety information for each student (including
          medications){" "}
          <b>
            <u>must</u>
          </b>{" "}
          be completed by the student’s parent(s) or legal guardian(s) to ensure
          we have accurate, shared knowledge of the student. Parent(s) or legal
          guardian(s) may only use an Education Consultant or interpreter for
          translation purposes for this section.
          <br></br>
          <br></br>
          The following questions will assist InvestIN in understanding each
          student’s medical history and specific needs during the programme.
          Please read each question carefully and answer with as much detail as
          required. For the avoidance of doubt, we ask that you use the red,
          amber, green (RAG), and blue, rating guidance below for each question:
          <br></br>
          <br></br>
          <div
            className="text-left"
            style={{ outline: "1px solid red", padding: "10px" }}
          >
            • Red - this is of great importance for the student’s learning
            experience, and they will regularly require additional support
            <br></br>• Amber - this is important for the student’s learning
            experience, and they will require some support, but can also support
            themself.
            <br></br>• Green - the student may require some extra support
            occasionally, but can mostly support themself
            <br></br>• Blue – this is for information only. The student is
            unlikely to need additional support but might need extra
            encouragement occasionally
          </div>
        </p>
        {Arr_Topics.map((Obj) => (
          <>
            <br></br>
            <h2>{Obj.Topic}</h2>{" "}
            <DisplayTextField
              formInfo={formInfo}
              handleChange={handleChange}
              Object={Arr_SENDInfo[Obj.ask]}
            />{" "}
            {formInfo[Obj.ask_title] === "Yes" &&
              Array.from(
                { length: Obj.end - Obj.start + 1 },
                (_, i) => Obj.start + i
              ).map((i) => (
                <>
                  <DisplayTextField
                    formInfo={formInfo}
                    handleChange={handleChange}
                    Object={Arr_SENDInfo[i]}
                  />
                </>
              ))}
            <br></br>
            <br></br>
          </>
        ))}
        <br></br>
        {/* ------------------------- */}
        <SEFChangePage Page={"SENDInfo"} PageButtonStatus={PageButtonStatus} />
        {isFormComplete ? (
          <></>
        ) : (
          <table>
            <thead>
              <tr>
                <th>
                  You can save this page at any point. To submit this page,
                  please complete the following questions first:
                </th>
              </tr>
            </thead>
            <tbody>
              {neededToSubmit.map((Obj) => {
                return (
                  <tr key={Obj.name}>
                    <td>{Obj.label}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}{" "}
        <h3>
          Once this page is completed and you have completed every question,
          please click "Submit" to complete the page and send it for review by
          InvestIN. Otherwise, click "Save" if you are not ready to complete the
          page and wish to return later to make changes
        </h3>
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.SENDInfo &&
                (SEFProgress.SENDInfo === "Complete" ||
                  SEFProgress.SENDInfo === "Awaiting_Review")) ||
              Object.keys(formInfo).length === 0
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.SENDInfo &&
                (SEFProgress.SENDInfo === "Complete" ||
                  SEFProgress.SENDInfo === "Awaiting_Review")) ||
              Object.keys(formInfo).length === 0
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewSEFSENDInfo;
